import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Observable, Subject, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientCodeService {
    // because this is app-component, it exits "higher in the stack" than the first route, which is where the clientCode param is set
    // so in the app component we cannot just read the params on the activated route
    // this code was lifted from CurrentStateService so it's been running for years

    public readonly clientCode$: Observable<string>;

    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);

    private readonly clientCodeSubject = new Subject<string>();
    private readonly routeSubscriptions: Subscription[] = [];

    constructor() {
        this.clientCode$ = this.clientCodeSubject.asObservable();

        // the routing tree seems to be rebuilt on certain router events, so we'll just re-subscribe every time we navigate
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe({
                next: () => {
                    this.routeSubscriptions.forEach((s) => s.unsubscribe());
                    this.routeSubscriptions.splice(0);  // empty the array
                    this.subscribeToRoute(this.route.root);
                },
            });
    }

    private subscribeToRoute(route: ActivatedRoute): void {
        this.routeSubscriptions.push(
            route.params
                .subscribe({
                    next: (params) => {
                        if (Object.keys(params).includes('clientCode')) {
                            this.clientCodeSubject.next(params.clientCode);
                        }
                    },
                }));

        route.children.forEach((r) => this.subscribeToRoute(r));
    }
}
